import { QueryClient } from '@tanstack/react-query';

/**
 * The default React Query client for app roots. Platform-specific
 * re-exports (e.g. the Next.js `'use client'` variant in `apps/web`)
 * should import this from here and then add their own top-of-file
 * pragma as needed — the core package has no framework assumptions.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
    },
  },
});
